import championOtf from './champion.otf';

export const Champion = {
    fontFamily: "Champion HTF-Welterweight",
    src: `url(${championOtf}) format("otf")`
}

//ttf fonts are loaded in fonts.css
export const Avenir = {
    fontFamily: "avenir",
   // src: `url(${avenirTtf}) format("truetype")`
}

export const Gilroy = {
    fontFamily: "gilroy",
    //src: `url(${gilroyTtf}) format("truetype")`
}